import { render } from "./CreatePlacement.vue?vue&type=template&id=28b5cc45"
import script from "./CreatePlacement.vue?vue&type=script&lang=js"
export * from "./CreatePlacement.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bogdanov.ea/Documents/goast-auth/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__